<template>
  <div class="cdb-resource-search">
    <Row :gutter="4" style="margin-bottom: 10px">
      <div>
        <Col span="6" v-if="companyIdShow == 1">
          <Select
            v-model="companyId"
            @on-change="changeCompanyID"
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option
              v-for="item in companyIdList"
              :value="item.id"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
        <Col span="6">
          <Select
            v-model="accountSearchKey"
            filterable
            multiple
            :max-tag-count="1"
            :placeholder="$t('RAM.common.PleaseEnterAccount')"
            @on-change="changeAccountId(accountSearchKey)"
            :transfer="true"
          >
            <Checkbox
              v-model="singleAccount"
              @on-change="selectAccountAll"
              style="display: block; text-align: right"
              v-if="accountList.length > 0"
              >{{ $t("alarms.common.allSelected") }}</Checkbox
            >
            <Option
              :value="item.id"
              v-for="item in accountList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
        <Col span="5">
          <Input
            v-model="accountName"
            :placeholder="$t('RAM.common.filterByAccountName')"
          />
        </Col>
        <Col span="5">
          <Input
            v-model="instanceId"
            :placeholder="$t('RAM.common.QuerybyInstanceID')"
          />
        </Col>
        <Col span="2">
          <Button
            v-hasPermission="[
              'resourceConfigurationManagement:tencent:cdbResource:page'
            ]"
            @click="search"
            >{{ $t("alarms.common.search") }}</Button
          >
        </Col>
      </div>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableCdbResource from "./TableCdbResource";
let tableCdbResource = TableCdbResource;
export default {
  name: "CdbResourceSearch",
  data() {
    return {
      companyIdShow: getCookie(global.companyId),
      companyId: "",
      accountName: "",
      companyIdList: [],
      accountSearchKey: [],
      accountList: [],
      instanceId: "",
      singleAccount: false
    };
  },
  mounted() {
    if (this.companyIdShow == 1) {
      this.listRegisterInformation();
    } else {
      this.queryTencentAccountBox();
    }
  },
  methods: {
    listRegisterInformation() {
      this.$api.user.listRegisterInformation().then(res => {
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.accountSearchKey = [];
        this.queryTencentAccountBox();
      });
    },
    queryTencentAccountBox() {
      if (this.companyIdShow != 1) {
        this.companyId = this.companyIdShow;
      }
      this.$api.account
        .queryTencentAccountBox("companyId", this.companyId)
        .then(res => {
          this.accountList = res.data;
          if (this.accountList) {
            for (let i = 0; i < this.accountList.length; i++) {
              this.accountSearchKey.push(this.accountList[i].id);
            }
          }
          this.search();
        });
    },
    changeCompanyID() {
      this.accountSearchKey = [];
      this.queryTencentAccountBox();
    },
    changeAccountId(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    selectAccountAll() {
      this.accountSearchKey = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountSearchKey.push(item.id);
        });
      } else {
        this.accountSearchKey = [];
      }
    },
    search() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountSearchKey", this.accountSearchKey);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("instanceId", this.instanceId);
      tableCdbResource.methods.showAll();
    }
  }
};
</script>
<style scoped>
.cdb-resource-search {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/cdb/CdbResourceSearch.vue